<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="pb-2">المنظمات الاهلية</h5>

                        </div>

                        <div class="col-6 header-titles">
                            <!-- <a routerLink="/content/admin/insert-partner" class="d-block">
                                <button class="btn pull-right" type="button">
                                    <span class="m-2">إدخال شريك</span>
                                    <i class="fa fa-plus"></i>
                                </button>
                            </a> -->
                        </div>
                    </div>
                </div>
                <div class="card-block row">
                    <div class="col-sm-12 col-lg-12 col-xl-12">
                        <div class="table-responsive">
                            <table class="table table-responsive-sm">
                                <thead>
                                    <tr class="">
                                        <th scope="col"></th>
                                        <th scope="col">الأسم</th>
                                        <th scope="col">نطاق العمل</th>
                                        <th scope="col">رقم الاشهار</th>
                                        <th scope="col">سنة الاشهار</th>
                                        <th scope="col"> رابط صفحه الفيس بوك</th>
                                        <th scope="col">اسم مسؤول التواصل</th>
                                        <th scope="col">رقم مسؤول التواصل</th>
                                        <th scope="col">التاريخ</th>
                                        <th scope="col">الملفات</th>

                                        <!-- <th scope="col"></th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let view of NGOrganizations;let x = index">
                                        <td scope="row" class="p-2">{{x+1}}</td>
                                        <td class="p-2">{{view.name}}</td>
                                        <td class="p-2">{{view.workDomain}}</td>
                                        <td class="p-2">{{view.publicationNo}}</td>
                                        <td class="p-2">{{view.publicationYear}}</td>
                                        <td class="p-2">{{view.facebookPageLink}}</td>
                                        <td class="p-2">{{view.contactPersonName}}</td>
                                        <td class="p-2">{{view.phoneNumer}}</td>
                                        <td class="p-2">{{view.creationDate | date:"dd/MM/yyyy"}}</td>

                                        <td class="p-2">
                                            <button style="padding: 7px; background-color: transparent;"
                                                (click)="GotoDetails(view);">
                                                <i class="fa fa-eye"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="d-flex justify-content-center">
                                <pagination [boundaryLinks]="true" [maxSize]="5" [totalItems]="totalCount"
                                    previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
                                    [itemsPerPage]="pager.maxResultCount" [(ngModel)]="pageNumber"
                                    (pageChanged)="pageChanged($event)">
                                </pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>